<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
// import axios from "axios";

import WorkflowMaintenanceForm from "../../../components/settings/workflowmaintenance/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": WorkflowMaintenanceForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: "Create Workflow Record",
      pageTitleValue: "",
      formData: {
        staffid: null,
        psndetails: null,
        compnyname: null,
        startdate: null,
        enddate: null,
        wftypeid: null,
        wftypedesc: null,
        detailid: null,
        leavecode: null,
        stamp: 0,
        userid: this.$store.getters.userId,
      },
      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    saveHandler() {
      const vm = this;

      this.$store.dispatch('post', {
          url: '/workflowmaintenance/param',
          payload: vm.formData
        })
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "workflowmaintenancelist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "workflowmaintenancelist" });
    },
  },
};
</script>